import ExpressedConsentPage from '../../src/client/pages/expressed-consent';

export default ExpressedConsentPage;
